export default "__VITE_ASSET__88260289__"